var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 10.375H7.66675C7.32508 10.375 7.04175 10.0917 7.04175 9.75C7.04175 9.40833 7.32508 9.125 7.66675 9.125H11.8334C12.1751 9.125 12.4584 9.40833 12.4584 9.75C12.4584 10.0917 12.1751 10.375 11.8334 10.375Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.4584C9.40833 12.4584 9.125 12.175 9.125 11.8334V7.66669C9.125 7.32502 9.40833 7.04169 9.75 7.04169C10.0917 7.04169 10.375 7.32502 10.375 7.66669V11.8334C10.375 12.175 10.0917 12.4584 9.75 12.4584Z",
    fill: "#717680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58341 18.125C4.87508 18.125 1.04175 14.2917 1.04175 9.58335C1.04175 4.87502 4.87508 1.04169 9.58341 1.04169C14.2917 1.04169 18.1251 4.87502 18.1251 9.58335C18.1251 14.2917 14.2917 18.125 9.58341 18.125ZM9.58341 2.29169C5.55841 2.29169 2.29175 5.56669 2.29175 9.58335C2.29175 13.6 5.55841 16.875 9.58341 16.875C13.6084 16.875 16.8751 13.6 16.8751 9.58335C16.8751 5.56669 13.6084 2.29169 9.58341 2.29169Z",
    fill: "#717680"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.9583C18.175 18.9583 18.0166 18.9 17.8916 18.775L16.225 17.1083C15.9833 16.8667 15.9833 16.4667 16.225 16.225C16.4666 15.9833 16.8666 15.9833 17.1083 16.225L18.775 17.8917C19.0166 18.1333 19.0166 18.5333 18.775 18.775C18.65 18.9 18.4916 18.9583 18.3333 18.9583Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchZoomIn);
export default __webpack_public_path__ + "static/media/search-zoom-in.89adf85e49b15338317ab9a8d2c3e053.svg";
export { ForwardRef as ReactComponent };